module.exports = __webpack_public_path__ + "299b3be898e809232985246037e615b9.woff";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensanssemibold.woff
// module id = 692
// module chunks = 57